import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptClass,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';

// Takes the model (not the diagram) so uniqueness checks work headlessly too —
// there's no diagram in the list view, but the model is always present.
export const hasIri = (iri: string, model: Model): boolean => {
  // check attributes
  if (model.modelData.attributesByIri[iri]) {
    return true;
  }
  // check classes
  const hasModelConceptClass = model.nodeDataArray.find(
    (node) => isModelConceptClass(node) && node.value === iri
  );
  if (hasModelConceptClass) {
    return true;
  }
  // check relationships
  const hasModelConceptRelationship = model.linkDataArray.find(
    (link) => isModelConceptRelationship(link) && link.value === iri
  );
  if (hasModelConceptRelationship) {
    return true;
  }

  return false;
};
